import { EuiFlexItem } from "@elastic/eui";
import "styles/components/filterDropdown/fd_filter_dropdown.css";

export const CustomCheckbox = ({
  onClick,
  isPartial = false,
  isChecked,
  isExcluded,
  disabled,
}: any) => {
  const classCondition = isPartial
    ? `custom_checkbox ${
        isChecked
          ? "checkbox_checked"
          : isExcluded
            ? "checkbox_excluded"
            : isPartial
              ? "checkbox_partial"
              : ""
      }`
    : `custom_checkbox ${isChecked ? "checkbox_checked" : isExcluded ? "checkbox_excluded" : ""}`;

  return (
    <EuiFlexItem grow={false} className="custom_check">
      <span
        onClick={onClick}
        style={{
          position: "relative",
          display: "inline-block",
          width: "16px",
          height: "16px",
        }}>
        <div
          className={classCondition}
          style={{
            minWidth: "16px",
            height: "16px",
            top: "50%",
            transform: "translateY(-50%)",
            ...(disabled
              ? { borderColor: "#495974", backgroundColor: isChecked ? "#495974" : "transparent" }
              : {}),
          }}
        />
      </span>
    </EuiFlexItem>
  );
};
